import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import './DBHAi.css';

const aiAssistants = [
  {
    id: 'ibc',
    name: 'IBC Legal Research Assistant',
    description: 'AI-powered legal research assistant for IBC-related research, case analysis, and regulatory compliance.',
    category: 'Legal Research',
    route: '/dbh-ai/ibcchatbot'
  },
  {
    id: 'rbi',
    name: 'RBI Banking Assistant',
    description: 'AI-powered assistant for RBI-related information, circulars, Master Directions, and banking regulations.',
    category: 'Banking & Regulatory',
    route: '/dbh-ai/rbichatbot'
  }
];

const DBHAi = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCardClick = (route) => {
    navigate(route);
  };

  const handleKeyDown = (e, route) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      navigate(route);
    }
  };

  return (
    <div className="dbh-ai-page">
      <div className="dbh-ai-container">
        {/* Header Section */}
        <motion.div
          className="dbh-ai-header"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="dbh-ai-eyebrow">DBH-AI</span>
          <h1 className="dbh-ai-title">AI Assistants Built for Smarter Decisions</h1>
          <p className="dbh-ai-description">
            Explore our specialized AI assistants designed to simplify research, analysis, and decision-making across different domains.
          </p>
        </motion.div>

        {/* Chatbot Grid */}
        <div className="dbh-ai-grid">
          {aiAssistants.map((assistant, index) => (
            <motion.div
              key={assistant.id}
              className="dbh-ai-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              onClick={() => handleCardClick(assistant.route)}
              onKeyDown={(e) => handleKeyDown(e, assistant.route)}
              tabIndex={0}
              role="link"
              aria-label={`Open ${assistant.name}`}
            >
              <div className="dbh-ai-card-content">
                <span className="dbh-ai-card-category">{assistant.category}</span>
                <h3 className="dbh-ai-card-name">{assistant.name}</h3>
                <p className="dbh-ai-card-description">{assistant.description}</p>
                <span className="dbh-ai-card-link">
                  Open Assistant <FiArrowRight className="arrow-icon" />
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DBHAi;
